import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';

const { colors, spacing, typography } = THEME;

export const styleSheet = StyleSheet.create({
	body: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.sm,
		padding: `0 ${spacing.lg}px`,
	},

	message: {
		color: colors.text.main,
		fontSize: typography.fontSizes.sm,
		margin: 0,
	},

	label: {
		color: colors.text.dark,
		fontSize: typography.fontSizes.sm,
		fontWeight: typography.fontWeights.semibold,
	},

	counter: {
		alignSelf: 'flex-end',
		color: colors.text.light,
		fontSize: typography.fontSizes.xs,
	},

	counterOverLimit: {
		color: colors.danger.main,
	},
});
